import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import { Button } from "layouts/Button";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
//import { green, purple } from "@material-ui/core/colors";
import "./HomeNavbar.css";
//import HeroSection from "../HeroSection/HeroSection";
import video from "assets/video/video-2.mp4";
//import img1 from "assets/svg/Inn.svg";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  customcolor: {
    color: theme.palette.common.white,
    border: "2px solid currentColor",
    margin: theme.spacing(1),
  },
}));

function HomeNavbar() {
  const classes = useStyles();

  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container" id="home">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            FTM
            <i className="fab fa-typo3" />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item" href="#home">
              <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <a
                className="nav-links"
                href="#product"
                onClick={closeMobileMenu}
              >
                Products
              </a>
              {/* <Link
                to="/services"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Services
              </Link> */}
            </li>
            <li className="nav-item">
              <a
                className="nav-links"
                href="#service"
                onClick={closeMobileMenu}
              >
                Services
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-links"
                href="#feature"
                onClick={closeMobileMenu}
              >
                Features
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-links"
                href="#contact"
                onClick={closeMobileMenu}
              >
                Contact
              </a>
              {/* <Link
                to="/products"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Products
              </Link> */}
            </li>

            <li>
              {/* <a
                href="/login"
                className="nav-links-mobile"
                onClick={closeMobileMenu}
              >
                Sign Up
              </a> */}
              <Link
                to="/signup"
                className="nav-links-mobile"
                onClick={closeMobileMenu}
              >
                Sign Up
              </Link>
            </li>
          </ul>
          {button && (
            //<Button buttonStyle="btn--outline" href="/login">
            <Button variant="contained" color="secondary" href="/signup">
              SIGN UP
            </Button>
          )}
        </div>
      </nav>

      <div className="hero-container">
        <video src={video} autoPlay loop muted />
        <h1>ADVENTURE AWAITS</h1>
        <p>What are you waiting for?</p>
        <div className="hero-btns">
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="secondary"
            href="/login"
          >
            GET STARTED
          </Button>
          <Button
            className={classes.customcolor}
            variant="outlined"
            size="large"
            //color="theme.palette.common.white"
            //onClick={console.log("Go to Product section")}
            href="#product"
          >
            MORE INFO
            <i className="far fa-play-circle" />
          </Button>
        </div>
      </div>

      {/* <HeroSection></HeroSection> */}
    </>
  );
}

export default HomeNavbar;
